module.exports = __webpack_public_path__ + "static/media/getelectron.b57cf5b6.png";